<template>
    <b-container class="h-100">
        <b-row v-if="trx" fluid="md" align-v="center" class="mh-100vh">
            <b-col v-if="!trxExitosa">
                <b-row v-if="!bloquear">
                    <b-col offset-md="3" md="6" class="mb-4">
                        <b-img :src="urlBaseS3 + '/header/logo-movired-rojo.png'" alt="Logo Movired" class="logo" center
                            height="25" />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-2">
                        <h5 class="text-center text-bold">Verifica los datos de tu compra</h5>
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-2" v-if="trx">
                        <b-card>
                            <h6 class="text-center titulo text-bold mb-3">
                                <!-- Tarjeta bip! -->
                                {{ trx.producto_nombre }}
                            </h6>

                            <b-table-simple small striped>
                                <b-tbody>
                                    <b-tr>
                                        <b-td class="border-top-0">
                                            <div class="text-right w-50 text-bold">
                                                N° de {{
                                                    trx.producto_nombre
                                                }}
                                            </div>
                                            <div class="text-left w-50">
                                                {{
                                                    trx.nro_tarjeta
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="border-top-0">
                                            <div class="text-right w-50 text-bold">
                                                Monto a pagar
                                            </div>
                                            <div class="text-left w-50">
                                                {{
                                                    new Intl.NumberFormat('es-CL', {
                                                        currency:
                                                            'CLP', style:
                                                            'currency'
                                                    }).format(trx.monto)
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="border-top-0">
                                            <div class="text-right w-50 text-bold">
                                                Correo electrónico
                                            </div>
                                            <div class="text-left w-50">
                                                {{ trx.email }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td class="border-top-0">
                                            <div class="text-right w-50 text-bold">
                                                N° de transacción
                                            </div>
                                            <div class="text-left w-50">
                                                {{
                                                    trx.identificador
                                                }}
                                            </div>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-card>
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-2" v-if="tokenMc">
                        <b-button variant="success" block @click="realizarPago">
                            Realizar pago
                        </b-button>
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-2" v-else>
                        <b-alert show variant="danger" class="text-center">
                            No tienes tarjetas inscritas, por favor registra una.
                        </b-alert>

                        <b-button variant="danger" block>
                            Inscribir tarjeta
                        </b-button>
                    </b-col>
                </b-row>
                <b-row v-if="bloquear">
                    <b-col offset-md="3" md="6">
                        <spinner></spinner>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="trxExitosa == true">
                <b-row>
                    <b-col offset-md="3" md="6" class="mb-3 mt-4">
                        <b-img :src="urlBaseS3 + '/pagos/cargaok.png'" alt="Logo Movired" class="logo mb-3" height="65"
                            center />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3">
                        <h5 class="text-center mb-2 text-bold">¡Carga exitosa!</h5>
                        <h5 class="text-center py-4">Enviamos el comprobante de tu compra al correo electrónico</h5>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="trxExitosa == false">
                <b-row>
                    <b-col offset-md="3" md="6" class="mb-3 mt-4">
                        <b-img :src="urlBaseS3 + '/pagos/cargafallida.png'" alt="Logo Movired" class="logo mb-3" height="65"
                            center />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3">
                        <h5 class="text-center mb-2 text-bold">¡Lo sentimos!</h5>
                        <h5 class="text-center py-4">
                            Hubo un error en la transacción y la <br>
                            carga no pudo realizarse. <br>
                            Inténtalo nuevamente en otro momento.</h5>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="!trx && paginaCargada" fluid="md" align-v="center" class="mh-100vh">
            <b-col>
                <b-row>
                    <b-col offset-md="3" md="6" class="mb-3 mt-4">
                        <b-img :src="urlBaseS3 + '/pagos/cargafallida.png'" alt="Logo Movired" class="logo mb-3" height="65"
                            center />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3">
                        <h5 class="text-center mb-2 text-bold">¡Lo sentimos!</h5>
                        <h5 class="text-center py-4">
                            Esta transacción ya ha expirado</h5>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { BRow, BCol, BContainer, BCard, BTableSimple, BTr, BTd, BButton, BImg, BTbody, BAlert } from 'bootstrap-vue';
import { mapActions, mapMutations, mapState } from "vuex";
import mixinAppRed from '../../../plugins/mixinAppRed';


export default {
    mixins: [mixinAppRed],
    props: {
        token: {
            type: String,
            value: null
        }
    },
    data() {
        return {
            trx: null,
            tokenMc: null,
            cliente: null,
            trxExitosa: null,
            paginaCargada: false
        };
    },
    components: {
        BRow,
        BCol,
        BContainer,
        BCard,
        BTableSimple,
        BTr,
        BTd,
        BButton,
        BImg,
        BTbody,
        BAlert,
        Spinner: () =>
            import(
                /* webpackChunkName: "spinner", webpackPrefetch: true */ "../../../components/spinner/Spinner.vue"
            )
    },
    namespaced: true,
    computed: {
        ...mapState(["bloquear", "urlBaseS3", "configuracionClienteBase"]),
    },
    methods: {
        ...mapActions(["resetearDatos", "actualizarConfiguracionCliente", "actualizarTransaccionRecibida", "actualizarTransaccionRecibidaCliente"]),
        ...mapMutations(["bloquearFalse", "bloquearTrue"]),
        async listarTrx() {
            let resTrx = await axios.post("/api/v1/getTrx", {
                token: this.token
            });

            if (resTrx.data) {
                this.trx = resTrx.data.trx
                this.tokenMc = resTrx.data.token
                this.cliente = resTrx.data.cliente
            }

            this.paginaCargada = true
        },
        async realizarPago() {
            this.bloquearTrue()

            let resToken = await axios.post("/api/generar/token", {
                cliente_id: this.cliente
            });

            if (resToken.data.token) {
                let resTransaccion = await axios.post("/api/v1/factibilidad", {
                    session_id: this.trx.session_id,
                    trx_id: this.trx.trx_id
                },
                    {
                        headers: { Authorization: `Bearer ${resToken.data.token}` }
                    }
                );

                if (resTransaccion.data.estado == true && resTransaccion.data.respuesta == "00") {
                    this.trxExitosa = true
                } else {
                    this.trxExitosa = false
                }

                this.bloquearFalse()
            } else {
                this.bloquearFalse()
            }
        }
    },
    mounted() {
        //this.resetearDatos()
        this.bloquearFalse()
        this.listarTrx()
    },
    created() {

    }
};
</script>

<style scoped>
@import "~bootstrap/dist/css/bootstrap.css";

.table-sm th,
.table-sm td {
    word-break: break-word !important;
}

@font-face {
    font-family: bariol;
    font-display: swap;
    src: url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff2") format("woff2"),
        url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff") format("woff");
}

table {
    font-weight: text-bold;
}

body,
.fondo-tr {
    background-color: #eaeaea;
    font-family: bariol !important;
    font-size: 1.25rem !important;
    color: #333;
}

.titulo {
    font-size: 1.5rem !important;
}

.container {
    height: 100vh;
    background-color: white;
}

.text-bold {
    font-weight: bold !important;
}

.mw-200 {
    min-width: 200px;
}

.mh-100vh {
    min-height: 100vh;
}

.card-body {
    padding: 0.5rem !important;
}

@media only screen and (max-width: 600px) {
    .titulo {
        font-size: 1.25rem;
    }
}

iframe {
    height: 800px;
}

.w-50 {
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    display: inline-block;
    float: left !important;
}

@media only screen and (max-width: 768px) {

    .w-50 {
        width: 100% !important;
        text-align: center !important;
    }
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: #eaeaea;
    font-family: bariol !important;
    font-size: 1.25rem !important;
    color: #333;
}
</style>
